import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * This is a component that returns the translated label for different user display modes
 * @param {number} props.mode - The number of the display mode
 */

function UserDisplayModes(props) {
  const mode = props.mode;

  switch (mode) {
    case 1:
      return (
        <span data-test="mode-1">
          <FormattedMessage
            id="userDisplayModes.showAllMonitoredDevices"
            defaultMessage="Show all monitored devices"
            description="Show all monitored devices"
          />
        </span>
      );

    case 2:
      return (
        <span data-test="mode-2">
          <FormattedMessage
            id="userDisplayModes.showOnlyActiveAlerts"
            defaultMessage="Show only active/recent alerts"
            description="Show only active/recent alerts"
          />
        </span>
      );
    case 4:
      return (
        <span data-test="mode-4">
          <FormattedMessage
            id="userDisplayModes.showQuickMessagScreen"
            defaultMessage="Show quick message screen"
            description="Show quick message screen"
          />
        </span>
      );

    case 5:
      return (
        <span data-test="mode-5">
          <FormattedMessage
            id="userDisplayModes.showManualAlarmScreen"
            defaultMessage="Show manual alarm screen"
            description="Show manual alarm screen"
          />
        </span>
      );

     case 6:
      return (
        <span data-test="mode-6">
          <FormattedMessage 
            id="userDisplayModes.showLowBatteryDevices"
            defaultMessage="Show low battery devices"
            description="Show low battery devices"
          />
        </span>
      );

      case 7:
        return (
          <span data-test="mode-7">
            <FormattedMessage
              id ="userDisplayModes.showTamperDevices"
              defaultMessage = "Show tamper devices"
              description = "Show tamper devices"
            />
          </span>
        );

      case 8:
        return (
          <span data-test="mode-8">
            <FormattedMessage
              id="userDisplayModes.showDormantDevices"
              defaultMessage="Show dormant devices"
              description="Show dormant devices"
            />
          </span>
        );
    // Added return to default that caused the page to break
    default:
      return null;
  }
}

export default UserDisplayModes;
